import React from 'react';

export default class Page5 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToUseOptimismToAchieve');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>HINTS AND TIPS TO REMAIN OPTIMISTIC
                                            </div>
                                            <div className="border_subtitle">Avoid negativity</div>
                                            <p>Spend time with people who have a positive outlook.</p>
                                            <div className="border_subtitle">Focus on strengths</div>
                                            <p>Olympic athletes didn’t focus on the sports they couldn’t do, but
                                                on becoming experts in the ones
                                                they were better at. Try doing the same. Acknowledge and manage
                                                your development areas ‐ but
                                                concentrate most of your energy in developing your strengths
                                                even further.</p>
                                            <div className="border_subtitle">If you can’t change it, manage it
                                                or ignore it
                                            </div>
                                            <p>Identify what you can change and forget the rest.</p>
                                            <div className="border_subtitle">Look for the hidden positives in
                                                situations
                                            </div>
                                            <p>Explore the potential benefits of the situation.</p>
                                            <div className="border_subtitle">Use positive language</div>
                                            <p>Eradicate ‘Yes, but’ from your vocabulary. </p>
                                            <div className="border_subtitle">Summary</div>
                                            <p>Remaining optimistic can simply be a case of reframing negative
                                                points to consider the more
                                                positive angles. Try to focus as much as possible on a
                                                solution-oriented view, especially when
                                                dealing with important, high pressure situations at work.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color task button-link-redirect">How to reframe problems</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeConfidentInYourJudgementCalls')}
                                                        className="link_color task button-link-redirect">How to be confident in
                                                        making judgement calls</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}
                                                        className="link_color task button-link-redirect">How to balance risk with
                                                        potential benefits.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Medvec, V. Madey,
                                                    S. &amp; Gilovich, T. (1995). When less is more:
                                                    Counterfactual thinking among Olympic
                                                    medalists,<span className="subtiltereg"> Journal of Personality and Social Psychology, 4.</span>
                                                </p></li>
                                                <li><p className="further_info_content">Seligman, M.
                                                    E., &amp; Csikszentmihalyi, M. (2000).<span
                                                        className="subtiltereg"> Positive psychology. The science of optimism and hope:
Research essays in honor of Martin EP Seligman, 415-429.</span></p></li>
                                                <li><p className="further_info_content">Segerstrom, S., et al.
                                                    (1998). Optimism is Associated With Mood, Coping, and Immune
                                                    Change in Response
                                                    to Stress.<span className="subtiltereg"> Journal of Personality and Social Psychology,</span> 74,
                                                    6.</p></li>
                                                <li><p className="further_info_content">Seligman, M.
                                                    (1990).<span
                                                        className="subtiltereg"> Learned Optimism.</span> New
                                                    York: Knopf. Free Press.</p></li>
                                                <li><p className="further_info_content"><span
                                                    className="subtiltereg">PK500 Mood and Emotion at Work.</span> June
                                                    2006, Survey 3. Pearn Kandola.</p></li>
                                                <li><p className="further_info_content">Glass, C. (2007). <span
                                                    className="subtiltereg">Solution Focussed Coaching: A Method for Applying Positive Psychology in the
Workplace.</span> Special Group in Coaching Psychology One Day Workshop.</p></li>
                                            </ol>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}